import { httpClient, ApiResponse } from '@/utils';
import {
  BlogCategoriesEndpoints,
  IBlogCategoriesListResponse,
  IBlogCategoryResponse,
  IBlogCategorySaveDTO,
  IDeleteBlogCategoryResponse,
} from '@/models/blogCategories.model';

class BlogCategoriesAPI {
  static getList(): ApiResponse<IBlogCategoriesListResponse> {
    return httpClient.get<IBlogCategoriesListResponse>(BlogCategoriesEndpoints.LIST);
  }

  static getById(id: string): ApiResponse<IBlogCategoryResponse> {
    return httpClient.get<IBlogCategoryResponse>(`${BlogCategoriesEndpoints.CATEGORY}/${id}`);
  }

  static create(data: IBlogCategorySaveDTO): ApiResponse<IBlogCategoryResponse> {
    return httpClient.post<IBlogCategoryResponse>(BlogCategoriesEndpoints.CATEGORY, data);
  }

  static update(id: string, data: IBlogCategorySaveDTO): ApiResponse<IBlogCategoryResponse> {
    return httpClient.patch<IBlogCategoryResponse>(`${BlogCategoriesEndpoints.CATEGORY}/${id}`, data);
  }

  static remove(id: string): ApiResponse<IDeleteBlogCategoryResponse> {
    return httpClient.delete<IDeleteBlogCategoryResponse>(`${BlogCategoriesEndpoints.CATEGORY}/${id}`);
  }
}

export default BlogCategoriesAPI;
